// This is a convention from the design teams
// most of out illustrations will have these dimensions.
export const DEFAULT_ILLUSTRATION_SIZES = {
    width: 256,
    height: 144,
};
